/**
 * RFC 4122 v4 id that also works outside secure contexts. `crypto.randomUUID`
 * only exists on https/localhost; a CE Web deployment served over plain http on
 * an IP has `crypto.getRandomValues` but not `randomUUID`.
 */
type UuidCrypto = Pick<Crypto, 'getRandomValues'> & { randomUUID?: () => string };

export function randomUuid(source: UuidCrypto = globalThis.crypto): string {
  if (typeof source.randomUUID === 'function') return source.randomUUID();
  const bytes = source.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
